import {
  getApiProjectsProjectIdCustomFieldsQueryKey,
  getApiProjectsProjectIdCustomFieldsQueryOptions,
  useDeleteApiProjectsProjectIdCustomFieldsCustomFieldId,
  useGetApiProjectsProjectIdCustomFields,
  usePatchApiProjectsProjectIdCustomFieldsCustomFieldId,
  usePostApiProjectsProjectIdCustomFields,
} from '@shape-construction/api/src/hooks';
import type { CustomFieldListSchema } from '@shape-construction/api/src/types';
import { useQueryClient } from '@tanstack/react-query';

// queries
/**
 * @deprecated use getProjectCustomFieldsQueryOptions instead
 */
export const useProjectCustomFields = useGetApiProjectsProjectIdCustomFields;
export const getProjectCustomFieldsQueryOptions = getApiProjectsProjectIdCustomFieldsQueryOptions;

// mutations
export const useCreateCustomField = () => {
  const queryClient = useQueryClient();

  return usePostApiProjectsProjectIdCustomFields({
    mutation: {
      onSuccess: (newCustomField, { projectId }) => {
        const oldCustomFieldsData = queryClient.getQueryData<CustomFieldListSchema>(
          getApiProjectsProjectIdCustomFieldsQueryKey(projectId)
        );

        queryClient.setQueryData(getApiProjectsProjectIdCustomFieldsQueryKey(projectId), {
          ...oldCustomFieldsData,
          customFields: [newCustomField, ...(oldCustomFieldsData?.customFields || [])],
        });
      },
    },
  });
};

export const useEditCustomField = () => {
  const queryClient = useQueryClient();

  return usePatchApiProjectsProjectIdCustomFieldsCustomFieldId({
    mutation: {
      onSuccess: (updatedCustomField, { projectId, customFieldId }) => {
        const oldCustomFieldsData = queryClient.getQueryData<CustomFieldListSchema>(
          getApiProjectsProjectIdCustomFieldsQueryKey(projectId)
        );

        queryClient.setQueryData(getApiProjectsProjectIdCustomFieldsQueryKey(projectId), {
          ...oldCustomFieldsData,
          customFields: oldCustomFieldsData?.customFields.map((customField) => {
            if (customField.id === customFieldId) {
              return updatedCustomField;
            }

            return customField;
          }),
        });
      },
    },
  });
};

export const useDeleteCustomField = () => {
  const queryClient = useQueryClient();

  return useDeleteApiProjectsProjectIdCustomFieldsCustomFieldId({
    mutation: {
      onSuccess: (_, { projectId, customFieldId }) => {
        const oldCustomFieldsData = queryClient.getQueryData<CustomFieldListSchema>(
          getApiProjectsProjectIdCustomFieldsQueryKey(projectId)
        );

        queryClient.setQueryData(getApiProjectsProjectIdCustomFieldsQueryKey(projectId), {
          ...oldCustomFieldsData,
          customFields: oldCustomFieldsData?.customFields.filter((customField) => customField.id !== customFieldId),
        });
      },
    },
  });
};
